var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 14.1667C7.00781 14.1667 4.58268 11.7415 4.58268 8.75V3.7963C4.58268 3.36449 4.58268 3.14859 4.66076 2.98115C4.74356 2.80359 4.88627 2.66088 5.06383 2.57808C5.23127 2.5 5.44717 2.5 5.87898 2.5H14.1197C14.5515 2.5 14.7674 2.5 14.9349 2.57808C15.1124 2.66088 15.2551 2.80359 15.3379 2.98115C15.416 3.14859 15.416 3.36449 15.416 3.7963V8.75C15.416 11.7415 12.9909 14.1667 9.99935 14.1667ZM9.99935 14.1667V17.5M14.166 17.5H5.83268M18.3327 4.16667V8.33333M1.66602 4.16667V8.33333",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.607e5f109d914168294e47bc3a2485e2.svg";
export { ForwardRef as ReactComponent };